import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

const firebaseConfig = {
    apiKey: "AIzaSyC4dH0eQrpZnqYkI5_zYnr9ATXDyQTKCbo",
    authDomain: "desiny-plus.firebaseapp.com",
    projectId: "desiny-plus",
    storageBucket: "desiny-plus.appspot.com",
    messagingSenderId: "839558876545",
    appId: "1:839558876545:web:b7a760c7e5a235b8fd2c80",
    measurementId: "G-9617CGG3NB"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();
  const storage = firebase.storage();
  
  export { auth, provider, storage };
  export default db;